import { regexName } from 'app/utils/validations';
import * as yup from 'yup';

export const createSchema = yup.object().shape({
  name: yup
    .string()
    .required('El nombre no puede quedar vacío')
    .min(3, 'El nombre debe contener al menos 3 letras')
    .matches(regexName, 'Solo letras y espacios entre nombres'),
  email: yup
    .string()
    .email('Debes ingresar un correo válido')
    .required('El correo no puede quedar vacío'),
  phone: yup
    .string()
    .min(10, 'Verifique que el número tenga 10 cifras al menos')
    .required('El número telefónico no puede quedar vacío'),
  password: yup
    .string()
    .required('Debes incluir una contraseña')
    .min(4, 'Contraseña muy corta - debe contener al menos 4 caracteres.'),
  password_confirmation: yup
    .string()
    .required('Debes confirmar la contraseña')
    .oneOf([yup.ref('password'), null], 'Las contraseñas no coinciden'),
  scopes: yup.array().notRequired(),
  role: yup.string().nullable(),
  status: yup.boolean(),
});
